import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 254,
    datas:[],
    account:"",

  },
  mutations: {
    increment (state) {
      state.count++
    },
    incredatas (state,arr){
      let arrs = state.datas;
      arrs.push(arr);
      state.datas = arrs;
    },
    deleteall(state){
      state.datas = [];
    },
    updatedatas(state,data){
      state.datas = data;
    }
  },
  actions:{
    asyncac(context){
      setTimeout(()=>{
        context.commit('increment')
      },2000)
    }
  },
  getters:{
    getcount(state){
      return '这个数据是：'+state.count;
    },
    getdatas(state){
      return state.datas
    }
  }
})
export default store;



// WEBPACK FOOTER //
// ./src/store/vuex.js